import { __assign } from "tslib";
import * as React from 'react';
import { forwardRef, memo } from 'react';
var Unblocked = memo(forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", ref: ref }, props),
    React.createElement("path", { d: "M6.101 6.101C11.568.634 20.433.634 25.9 6.101s5.467 14.332 0 19.799c-5.467 5.467-14.332 5.467-19.799 0s-5.467-14.332 0-19.799zm16.97 1.414L7.515 23.071a.999.999 0 0 0 1.32 1.497l.094-.083L24.485 8.929a.999.999 0 0 0-1.32-1.497l-.094.083z" }))); }));
Unblocked.displayName = 'Unblocked';
Unblocked['iconName'] = 'unblocked';
export default Unblocked;
